import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export const homeForRole = (role) => ({ admin: "/admin", doctor: "/medico", nurse: "/infermiere" }[role] || "/area-riservata");

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = verifica in corso, false = anonimo

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setUser(false);
      return false;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const applyAuth = (data) => {
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const value = useMemo(
    () => ({
      user,
      setUser,
      refresh,
      login: async (email, password) => applyAuth((await api.post("/auth/login", { email, password })).data),
      registerDoctor: async (payload) => applyAuth((await api.post("/auth/register/doctor", payload)).data),
      registerNurse: async (payload) => applyAuth((await api.post("/auth/register/nurse", payload)).data),
      logout: () => {
        localStorage.removeItem(TOKEN_KEY);
        setUser(false);
        api.post("/auth/logout").catch(() => {});
      },
    }),
    [user, refresh]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
